<template>
  <div :class="$style.component">
    <div :class="$style.titleContainer">
      <div :class="$style.title">{{ label }}</div>
      <icon
          v-if="showInfo"
          @click.native="infoClicked"
          icon="info-filled"
          :class="$style.info"
      ></icon>
      <span v-if="optional" :class="$style.optional">{{optionalLabel}}</span>
    </div>
    <p :class="$style.description" v-if="hasSlotContent">
      <slot></slot>
    </p>

    <v-select
        :options="options"
        :class="[
            `visible-option-count-${visibleOptions}`,
            isInvalid ? 'invalid' : '',
            $style[size]
            ]"
        :placeholder="placeholder"
        :resetOnOptionsChange="resetOnOptionsChange"
        @input="selectOption"
        @search="search"
    >
      <div slot="no-options">{{noOptionsLabel}}</div>
      <li v-if="listFooterLabel" style="text-align: center" slot="list-footer">{{listFooterLabel}}</li>
    </v-select>

    <div>
      <slot name="result"></slot>
    </div>
  </div>
</template>

<script>

import icon from "../display/icon";
import vSelect from 'vue-select';

export default {
  name: "filterable-drop-down-component",

  components: {
    icon,
    'v-select': vSelect
  },

  props: {
    options: { type: Array, required: true },
    label: { type: String, required: true },
    showInfo: { type: Boolean, default: false }, // Show info icon
    optional: { type: Boolean, default: false },
    optionalLabel: { type: String, default: "Optioneel" },
    noOptionsLabel: { type: String, default: "Geen resultaten gevonden" },
    listFooterLabel: { type: String, default: "" },
    placeholder: { type: String, required: true },
    resetOnOptionsChange: { type: Boolean, default: false },
    value: { type: String },
    isInvalid: { type: Boolean, default: false },
    visibleOptions: {
      type: Number,
      default: 2,
      validator: function(value) {
        return value >= 1 && value <= 10;
      }
    },
    size: {
      type: String,
      default: "max",
      validator: function(value) {
        return ["small", "medium", "max"].indexOf(value) !== -1;
      }
    }
  },
  computed: {
    hasSlotContent() {
      return this.$slots && this.$slots.default && this.$slots.default.length;
    }
  },
  methods: {
    selectOption(option) {
      this.$emit('input', option ? option.value : null);
    },
    infoClicked() {
      this.$emit("info-clicked");
    },
    search(search, loading) {
      this.$emit('search', search, loading);
    }
  }
}
</script>

<style module lang="scss">
@import "../../style/modules/input.module";

:global {
  @import "~vue-select/src/scss/vue-select.scss";

  $max-visible-options: 10;
  @for $i from 1 through $max-visible-options {
    .visible-option-count-#{$i} > .vs__dropdown-menu {
      max-height: (50px * $i);
    }
  }

  // Duplicated from default input styling to allow proper selectors for vue-select
  .small > .vs__dropdown-toggle, .vs__dropdown-menu {
    width: 25%;
  }
  .medium > .vs__dropdown-toggle, .vs__dropdown-menu {
    width: 50%;
  }
  .max > .vs__dropdown-toggle, .vs__dropdown-menu {
    width: 100%;
  }

  .vs__search::placeholder,
  .vs__dropdown-toggle {
    outline: none;
    font-size: rem-calc(15);
    font-family: $font-family;
    border-radius: rem-calc(4);
    margin-top: rem-calc($spacing-m);
    padding: rem-calc(11.5) rem-calc(15);
    border: rem-calc(1) solid $color-dimgrey-lighter;
  }

  .invalid > .vs__dropdown-toggle {
    border-color: $color-attention;
    background-color: $color-attention-light;
  }

  .vs__dropdown-menu {
    border: rem-calc(1) solid $color-dimgrey-lighter;
    padding: 0;
  }

  .vs__dropdown-option {
    font-size: rem-calc(15);
    padding: rem-calc(11.5) rem-calc(15);
  }

  .vs__dropdown-option--highlight {
    background-color: $color-primary;
    color: $color-white;
    border-radius: 0;
  }
}
</style>